<div class="mt-2 p-2 border rounded">
  <div class="row">
    <div class="col-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="IsWhThVisible"
          [(ngModel)]="variables['IsWhThVisible']"
          (ngModelChange)="onCheckboxChange()"
        />
        <label class="form-check-label" for="IsWhThVisible">Wh/Th Visible</label>
      </div>
    </div>
  </div>
</div>
